import type { CbiFrontendServiceContext } from "../../frontend/context/CbiFrontendServiceContext";
import type { ApClassAttendanceStaff } from "./ApClassAttendanceStaff";
import type { ApClassSignupDTOBase } from "./ApClassSignupDTOBase";
import type { ApClassStaff } from "./ApClassStaff";
import type { ApClassWlResultStaff } from "./ApClassWlResultStaff";
import type { ClassProgress } from "./ClassProgress";
import type { LineItemRef } from "./LineItemRef";
import type { PersonStaff } from "./PersonStaff";
import type { PurchasableState } from "./PurchasableState";
import type { TrackedBase } from "./TrackedBase";

export class ApClassSignupStaff implements ApClassSignupDTOBase, TrackedBase {
  constructor(public readonly signupId: number, public readonly orderId: number | null, public readonly signupDatetime: Date, public readonly signupType: string, public readonly ccTransNum: string | null, public readonly closeId: number | null, public readonly discountInstanceId: number | null, public readonly paymentMedium: string | null, public readonly price: number | null, public readonly sequence: number, public readonly voidCloseId: number | null, public readonly paymentLocation: string | null, public readonly signupNote: string | null, public readonly voidedOnline: string | null, public readonly compassOrderID: number | null, public readonly purchasableState: PurchasableState, public readonly purchaseDate: Date | null, public readonly lineItems: Array<LineItemRef> | null, public readonly classProgress: ClassProgress, public readonly wlResult: ApClassWlResultStaff | null, public readonly createdOn: Date | null, public readonly createdBy: string | null, public readonly updatedOn: Date | null, public readonly updatedBy: string | null, public readonly instanceId: ApClassStaff | null, public readonly personId: PersonStaff | null, public readonly attendance: Array<ApClassAttendanceStaff> | null) {
    this.cbiServiceContext = null;
    this.wlResultLoaded = this.wlResult != null;
    this.wlResultCached = this.wlResult;
    this.instanceIdLoaded = this.instanceId != null;
    this.instanceIdCached = this.instanceId;
    this.personIdLoaded = this.personId != null;
    this.personIdCached = this.personId;
    this.attendanceLoaded = this.attendance != null;
    this.attendanceCached = this.attendance;
  }
  cbiServiceContext: CbiFrontendServiceContext | null;
  private wlResultLoaded: boolean;
  private wlResultCached: ApClassWlResultStaff | null;
  private instanceIdLoaded: boolean;
  private instanceIdCached: ApClassStaff | null;
  private personIdLoaded: boolean;
  private personIdCached: PersonStaff | null;
  private attendanceLoaded: boolean;
  private attendanceCached: Array<ApClassAttendanceStaff> | null;
  async wlResultLazy(): Promise<ApClassWlResultStaff | null> {
    if (!this.wlResultLoaded) {
      this.wlResultCached = await this.cbiServiceContext!.apClassService().getApClassSignupStaffWlResult(this.signupId);
      this.wlResultLoaded = true;
    }
    return this.wlResultCached;
  }
  async instanceIdLazy(): Promise<ApClassStaff> {
    if (!this.instanceIdLoaded) {
      this.instanceIdCached = await this.cbiServiceContext!.apClassService().getApClassSignupStaffInstanceId(this.signupId);
      this.instanceIdLoaded = true;
    }
    return this.instanceIdCached!;
  }
  async personIdLazy(): Promise<PersonStaff | null> {
    if (!this.personIdLoaded) {
      this.personIdCached = await this.cbiServiceContext!.apClassService().getApClassSignupStaffPersonId(this.signupId);
      this.personIdLoaded = true;
    }
    return this.personIdCached;
  }
  async attendanceLazy(): Promise<Array<ApClassAttendanceStaff>> {
    if (!this.attendanceLoaded) {
      this.attendanceCached = await this.cbiServiceContext!.apClassService().getApClassSignupStaffAttendance(this.signupId);
      this.attendanceLoaded = true;
    }
    return this.attendanceCached!;
  }
}
